import { Skeleton, styled } from "@mui/material";
import GKTypography from "./GKTypography";

const StyledGridOverlay = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
}));

export const CustomLoader = () => {
  return (
    <StyledGridOverlay>
      {Array.from({ length: 10 })?.map((_, index) => {
        return (
          <Skeleton
            key={index}
            sx={[
              () => ({
                p: 2,
                width: "100%",
                borderBottom: `solid 1px var(--neutral-100)`,
              }),
            ]}
          />
        );
      })}
    </StyledGridOverlay>
  );
};

export const Pagination = () => {
  return <div> </div>;
};

export const EmptyData = (props: any) => {
  const { emptyButtons } = props;
  return (
    <StyledGridOverlay>
      <img
        alt=""
        src="/LandingPage/noDataImg.svg"
        height={200}
        width={"auto"}
      />
      <GKTypography fontWeight={600} fontSize={16}>
        No Data Found
      </GKTypography>
      {emptyButtons}
    </StyledGridOverlay>
  );
};
